import axios from "axios";
import { ActionTree } from "vuex";
import { IState } from "./types";

export const actions: ActionTree<IState, IState> = {
    async fetchAlbums({commit}) : Promise<any> {
        try {
            const response = await axios.get(process.env.VUE_APP_API_DOMAIN + "/api/albums/");
            return commit("SET_ALBUMS", response.data.albums);
        } catch (e) {
            console.error(e);
        }
    },
    async fetchAlbum({commit}, id: number) : Promise<any> {
        try {
            const response = await axios.get(process.env.VUE_APP_API_DOMAIN + "/api/albums/" + id);
            return commit("SET_MEDIAS_TO_SHOW", response.data.album);
        } catch (e) {
            console.error(e);
        }
    },
    setScrollPosition({commit}, position: number) {
        commit("SET_SCROLL_POSITION", position);
    },
    setCurrentMediaIndex({commit}, index?: number) {
        commit("SET_CURRENT_MEDIA_INDEX", index);
    },
    closeGallery({commit}) {
        commit("SET_IS_GALLERY_OPEN", false);
    },
    openGallery({commit}) {
            commit("SET_IS_GALLERY_OPEN", true);
    },
    async fetchInitializedSiteData({commit}) : Promise<any> {
        try {
            const response = await axios.get(process.env.VUE_APP_API_DOMAIN + "/api/company/");
            return commit("SET_INITIALIZED_SITE_DATA", response.data);
        } catch (e) {
            console.error(e);
        }
    },
};
